import * as angular from 'angular';

(() => {
    'use strict';

    /**
     * @ngdoc component
     * @name pkpFcfsMaintenancePage
     * @memberof app
     *
     * @description
     * Page which shows maintenance messages of the tsos of the chosen networkpoint in fcfs booking.
     *
     * This page will be shown, if at least one of the tsos has a maintenance period.
     *
     * @author somarten.btc
     */
    angular.module('app').component('pkpFcfsMaintenancePage', {
        template:
            require('app/fcfs-booking/pkp-fcfs-maintenance-page.component.html'),
        controller: PkpFcfsMaintenancePageCtrl,
        bindings: {}
    });

    function PkpFcfsMaintenancePageCtrl(fcfsBookingService) {
        var vm = this;
        vm.maintenaceMessageList = fcfsBookingService.tsoMaintenanceMessages;
    }
})();
